
import { getCustomUserAgent, getCustomUserAgentASB, getCustomUserAgentJKHInfo, getCustomUserAgentKrk, getCustomUserAgentOirc } from "../../../customUserAgent";
import "../styles/Header.css";
import { $SiteColors } from "../../../config/company-atts";
import { InputSearch } from "../molecules/InputSearch";
import { Notifications } from "../molecules/Notifications";
import { UserInfo } from "../molecules/UserInfo";
import { CustomLogo } from "../molecules/CustomLogo";
import { JKHInfoLogo } from "../molecules/JKHInfoLogo";
import { KRKLogo } from "../molecules/KRKLogo";
import { OircLogo } from "../molecules/OircLogo";
import { ASBLogo } from "../molecules/ASBLogo";


export const Header = () => {
  let currCUA = getCustomUserAgent()
  return (
    <header
      className="header"
      style={{ background: $SiteColors.getState().headerColor,  boxShadow: $SiteColors.getState().headerShadow }}
    >
      {currCUA == getCustomUserAgentJKHInfo()? <JKHInfoLogo/> :
       currCUA==getCustomUserAgentKrk()? <KRKLogo/>:
       currCUA==getCustomUserAgentASB()? <ASBLogo/>:
       currCUA==getCustomUserAgentOirc()? <OircLogo/>:
       <CustomLogo/>
       }
      <InputSearch />
      <Notifications />
      <UserInfo />
    </header>
    )
  /*return (
    <header
      className="header"
      style={{ background: headerColor, boxShadow: headerShadow }}
    >
      <KRKLogo />
      <InputSearch />
      <Notifications />
      <UserInfo />
    </header>
  );*/
};
